var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"history-table",attrs:{"data-testid":"history-table"}},[_c('DataTable',{attrs:{"columns":_vm.columns,"data":_vm.data,"status":_vm.status},on:{"on-button-click":_vm.redirectToMargimEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }